import { render, staticRenderFns } from "./appMenu.vue?vue&type=template&id=f90c3f1a&scoped=true&"
import script from "./appMenu.vue?vue&type=script&lang=ts&"
export * from "./appMenu.vue?vue&type=script&lang=ts&"
import style0 from "./appMenu.vue?vue&type=style&index=0&id=f90c3f1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90c3f1a",
  null
  
)

export default component.exports